import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ConvertToString from "../../../components/Converter";
import PlusIcon from "../../../components/Icons/PlusIcon";
import Millimetre from "../../../components/Math/Units/Metric/Millimetre";
import { RowBody } from "../../../components/RowValue/RowBody";
import { selectBohrkronendurchmesser } from "../../../store/slices/bohrkronendurchmesserSlice";
import DrillBitDiameterDropDown from "./DrillBitDiameterDropDown";

function DrillBitDiameter({ readOnly = false, showModal }) {
  const { t } = useTranslation("translation");
  const bohrkronendurchmesser = useSelector(selectBohrkronendurchmesser);

  return (
    <RowBody
      titleValue={<p>{t("inner.verificationCapacity.drillBitDiameter")}</p>}
      formulaValue={
        readOnly ? null : (
          <span className="input--formula" onClick={() => showModal(true)}>
            <PlusIcon />
          </span>
        )
      }
      indicesValue={<span>D</span>}
      inputValue={
        readOnly ? (
          <span className="input">{ConvertToString(bohrkronendurchmesser)}</span>
        ) : (
          <DrillBitDiameterDropDown />
        )
      }
      unitValue={<Millimetre />}
    />
  );
}

export default DrillBitDiameter;
